import { debounce } from "../utils/performance";

export default function(el) {
    const innerComponent = el.querySelector(".pc__inner > *:first-child");

    const setComponentHeight = () => {
        if (el.offsetHeight !== innerComponent.offsetHeight)
            el.style.setProperty("--pc-height", `${innerComponent.offsetHeight}px`);
    };

    const handleResizeEvent = debounce(setComponentHeight, 100);

    if (!innerComponent) return;

    window.addEventListener("resize", handleResizeEvent);
    setComponentHeight();
}
